import { render, staticRenderFns } from "./batchadd.vue?vue&type=template&id=467060d8&"
import script from "./batchadd.vue?vue&type=script&lang=js&"
export * from "./batchadd.vue?vue&type=script&lang=js&"
import style0 from "./batchadd.vue?vue&type=style&index=0&id=467060d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports